import { useTranslations } from 'next-intl'

import { TextButton } from '@/shared/ui'

type Props = {
  onClick: () => void
}

export const MobileDeleteButton = ({ onClick }: Props) => {
  const t = useTranslations('search_panel')

  return (
    <TextButton size="small" color="gray" onClick={onClick}>
      {t('recent_keyword.button.delete_all')}
    </TextButton>
  )
}
